import { Notify } from 'components/Notifications/Notifications';

const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text);
  Notify.success(`"${text}" copied to clipboard`);
};

export default copyToClipboard;
